var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({staticClass:"input-file",attrs:{"type":"file"},on:{"change":_vm.setValue,"focus":function($event){_vm.pristine = false}}},'input',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }